//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import support from '@/scripts/support.json'

import FaqItem from '@/components/elements/FaqItem'

export default {
  name: 'Faq',
  components: { FaqItem },
  data() {
    return {
      email: support.email,
    }
  },
  computed: {
    ...mapState('nav', ['sideNav']),
  },
}
